<div class="ds-grid ds-grid--1">
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Basic Tabs</h3>
			<p class="ds-example__header-subtitle">Text-only tabs; the parent controls the content via activeTabId</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-tabs
				[tabs]="basicTabs"
				[activeTabId]="basicActiveId"
				(tabChange)="onTabChange('basic', $event)">
				@switch (basicActiveId) {
					@case ('overview') {
						<p class="mt-3">Overview content</p>
					}
					@case ('details') {
						<p class="mt-3">Details content</p>
					}
					@case ('history') {
						<p class="mt-3">History content</p>
					}
				}
			</eif-custom-tabs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Tabs with Icons</h3>
			<p class="ds-example__header-subtitle">Each tab can display a Font Awesome icon</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-tabs
				[tabs]="iconTabs"
				[activeTabId]="iconsActiveId"
				(tabChange)="onTabChange('icons', $event)">
				<p class="mt-3">Active tab: {{ iconsActiveId }}</p>
			</eif-custom-tabs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Conditional Tabs</h3>
			<p class="ds-example__header-subtitle">Tabs with condition set to false are hidden</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group mb-3">
				<eif-custom-button
					[text]="showAdvancedTab ? 'Hide Advanced tab' : 'Show Advanced tab'"
					[variant]="'outlined'"
					[size]="'small'"
					(action)="toggleAdvancedTab()">
				</eif-custom-button>
			</div>
			<eif-custom-tabs
				[tabs]="conditionalTabs"
				[activeTabId]="conditionalActiveId"
				(tabChange)="onTabChange('conditional', $event)">
				<p class="mt-3">Active tab: {{ conditionalActiveId }}</p>
			</eif-custom-tabs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Overflow</h3>
			<p class="ds-example__header-subtitle">Navigation arrows appear when the tabs do not fit the available width</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-tabs
				[tabs]="overflowTabs"
				[activeTabId]="overflowActiveId"
				(tabChange)="onTabChange('overflow', $event)">
				<p class="mt-3">Active tab: {{ overflowActiveId }}</p>
			</eif-custom-tabs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Declarative Actions</h3>
			<p class="ds-example__header-subtitle">
				Buttons and menus via the actions input; they collapse into a menu when space is limited. Last action: {{ lastAction }}
			</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-tabs
				[tabs]="iconTabs"
				[actions]="actions"
				[activeTabId]="actionsActiveId"
				(tabChange)="onTabChange('actions', $event)">
				<p class="mt-3">Active tab: {{ actionsActiveId }}</p>
			</eif-custom-tabs>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Projected Actions (legacy)</h3>
			<p class="ds-example__header-subtitle">Custom content projected in the eifTabActions slot</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-tabs
				[tabs]="basicTabs"
				[activeTabId]="legacyActiveId"
				(tabChange)="onTabChange('legacy', $event)">
				<div eifTabActions>
					<eif-custom-button
						[text]="'Projected action'"
						[size]="'small'"
						(action)="onLegacyAction()">
					</eif-custom-button>
				</div>
				<p class="mt-3">Active tab: {{ legacyActiveId }}</p>
			</eif-custom-tabs>
		</div>
	</div>
</div>
